import { Button, Modal } from "antd"
import React from "react"

const LowImage = (props: { lowImage, setLowImage }) => {
  return (
    <Modal
      open={props.lowImage}
      footer={[<Button key={"low_res_ok_button"} onClick={() => props.setLowImage(false)}>Valider</Button>]}
      onCancel={() => props.setLowImage(false)}
      title="Erreur"
      key={'low image'}
    >
      <span>
        L'image prise par la caméra n'est pas de résolution suffisante pour lancer le traitement. Veuillez augmenter la résolution.
      </span>
    </Modal>
  )
}

export default LowImage